// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Faq_section} from './toolip/faq_section';
import styles from './toolip/faq_section.module.less';
import hola_opt from 'hola_opt';
import {obj_to_arr} from '../ui/use_cases/use_case_faq';

export const Shared_dc_faq = ()=>{
    const collection =
        hola_opt.intercom_articles?.['FAQ']?.['Shared Datacenter Proxies']
        || [];
    return <div className={styles.faq}>
      <Faq_section custom_questions={obj_to_arr(collection)}
      color="transparent" no_title/>
    </div>;
};

export const Dedicated_dc_faq = ()=>{
    const collection =
        hola_opt.intercom_articles?.['FAQ']?.['Dedicated Datacenter Proxies']
        || [];
    return <div className={styles.faq}>
      <Faq_section custom_questions={obj_to_arr(collection)}
      color="transparent" no_title/>
    </div>;
};

export const Isp_plus_faq = ()=>{
    const collection =
        hola_opt.intercom_articles?.['FAQ']?.['Static Residential proxies']
        || [];
    return <div className={styles.faq}>
      <Faq_section custom_questions={obj_to_arr(collection)}
      color="transparent" no_title/>
    </div>;
};

export const Smart_resi_faq = ()=>{
    const collection =
        hola_opt.intercom_articles?.['FAQ']?.['Rotating residential proxies']
        || [];
    return <div className={styles.faq}>
      <Faq_section custom_questions={obj_to_arr(collection)}
      color="transparent" no_title/>
    </div>;
};
